/**
 * ComingSoon Page - Placeholder for unimplemented pages
 * Shows page name and a "Coming Soon" message
 */

import { useLocation } from 'react-router-dom';
import { Construction } from 'lucide-react';

export function ComingSoon() {
  const location = useLocation();

  // Derive a readable page name from the route path
  const pageName = location.pathname
    .split('/')
    .filter(Boolean)
    .map((segment) =>
      segment
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    )
    .join(' / ');

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted">
        <Construction size={32} className="text-muted-foreground" />
      </div>
      <div className="space-y-2">
        <h2 className="text-2xl font-semibold text-foreground">Coming Soon</h2>
        <p className="text-sm text-muted-foreground">
          The <span className="font-medium text-foreground">{pageName}</span> page is
          under development.
        </p>
      </div>
    </div>
  );
}
